require('../../modules/es6.reflect.set');
module.exports = require('../../modules/_core').Reflect.set;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/reflect/set.js
// module id = 690
// module chunks = 1